import { render, staticRenderFns } from "./myBill.vue?vue&type=template&id=5428fd06&scoped=true"
import script from "./myBill.vue?vue&type=script&lang=js"
export * from "./myBill.vue?vue&type=script&lang=js"
import style0 from "./myBill.vue?vue&type=style&index=0&id=5428fd06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5428fd06",
  null
  
)

export default component.exports